import httpClient from "@/plugins/axios";

export const getPeople = async (page, pageSize = 10) => {
    const response = await httpClient.get(`/v1/people/?page=${page}&page_size=${pageSize}`);
    return response;
}

export const searchPersons = async (query) => {
    const response = await httpClient.get(`/v1/people/search/?search=${encodeURIComponent(query)}`);
    return response;
}